import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import {getOutputHashFormat} from "@angular/cli/models/webpack-configs";
import { FileStorageService } from '../../services';
import { PhotoAreaService } from '../../services';
import {
  IGalleryImageDescription,
  IImageIcon,
  INgxGalleryImage,
} from '../../user-controls/ngx-gallery/ngx-gallery-image.model';
import { INgxGalleryOptions } from '../../user-controls/ngx-gallery/ngx-gallery-options.model';
import { StepType } from './step.type';
import moment from 'moment';
import { IPhotoAreaCondition } from '../../interfaces/task-info';
import { IPhotoArea } from '../../interfaces/photo-area';
// import { ClassField } from "@angular/compiler/src/output/output_ast";

interface IUrlKey {
  key: string;
  url: string;
}

@Component({
  selector: 'job-screen-gallery',
  templateUrl: './job-screen-gallery.component.html',
  styleUrls: ['./job-screen-gallery.component.scss'],
})
export class JobScreenGalleryComponent implements OnInit {
  galleryImages: INgxGalleryImage[];
  galleryOptions: INgxGalleryOptions[];
  selectedImage: IGalleryImage;
  selectedStyle: string;

  cachedUrls: IUrlKey[] = [];
  //static _cachedUrls: IUrlKey[];
  //get cachedUrls() { return JobScreenGalleryComponent._cachedUrls; }

  conditionFilters: ConditionFilter[];
  descriptionFilter: DescriptionFilter;
  signaturesFilter: SignaturesFilter;

  photoAreas: IPhotoArea[];

  @Input() showAddButton: boolean;
  @Input() disableAddButton: boolean;

  private _type: StepType;
  @Input() set type(value: StepType) {
    this._type = value;
  }
  get type(): StepType {
    return this._type;
  }

  private _images: IGalleryImage[];
  @Input('images')
  set images(value: IGalleryImage[]) {
    this._images = value;
    this.refreshImages();
  }
  get images(): IGalleryImage[] {
    return this._images;
  }

  @Output() onAddPhoto = new EventEmitter();
  @Output() onSetAreaCondition = new EventEmitter();
  @Output() onDeletePhoto = new EventEmitter();
  @Output() onEditPhoto = new EventEmitter();

  @Output() onShowOdometerPhoto = new EventEmitter();

  constructor(
    private fileStorageService: FileStorageService,
    private photoAreaService: PhotoAreaService,
  ) {
    this.conditionFilters = [
      new ConditionFilter(0),
      new ConditionFilter(1),
      new ConditionFilter(2),
      new ConditionFilter(3),
      new ConditionFilter(4),
    ];
    this.descriptionFilter = new DescriptionFilter();
    this.signaturesFilter = new SignaturesFilter();
  }

  ngOnInit(): void {
    this.setColorScheme();

    this.getPhotoAreas();

    this.galleryOptions = [
      {
        //lazyLoading: false - Doing so all images are loaded in cache and then when use lists down the images then the gallery doesn't request
        //s3-presigned image which is expired by that moment
        lazyLoading: false,
        image: false,
        height: '210px',
        width: '100%',
        thumbnailsColumns: 4,
        thumbnailsSwipe: true,
        previewZoom: true,
        previewCloseOnClick: false,
        previewCloseOnEsc: true,
        thumbnailShowPreviewOnAction: true,
        thumbnailSelectedBorderStyle: this.selectedStyle,
        zoomInIcon: 'fa fa-plus',
        zoomOutIcon: 'fa fa-minus',
      },
      {
        breakpoint: 768, // @media max-width 768
        thumbnailsColumns: 2,
      },
      {
        breakpoint: 1024, // @media max-width 1024
        thumbnailsColumns: 3,
      },
      {
        breakpoint: 1600, // @media max-width 1600
        thumbnailsColumns: 4,
      },
      {
        breakpoint: 460, // @media max-width 460
        thumbnailsColumns: 1,
      },
    ];
  }

  getPhotoAreas(): void {
    this.photoAreaService.getAll().then((areas) => {
      this.photoAreas = areas;
    });
  }

  handleSelectedImageChange(params: any) {
    this.selectedImage = params.image.origin;
  }

  handleChangeFilter() {
    this.refreshImages();
  }

  addPhoto() {
    this.onAddPhoto.emit(this.type);
  }

  deletePhoto() {
    this.onDeletePhoto.emit(this.selectedImage);
  }

  editPhoto() {
    this.onEditPhoto.emit(this.selectedImage);
  }

  setAreaCondition() {
    this.onSetAreaCondition.emit({ type: this.type, image: this.selectedImage });
  }

  clearCachedUrl(key) {
    let i = this.cachedUrls.findIndex((p) => p.key == key);
    if (i >= 0) this.cachedUrls.splice(i, 1);
  }

  getCachedUrl(key): string {
    let o = this.cachedUrls.find((p) => p.key == key);
    return o ? o.url : null;
  }

  refreshImages() {
    this.photoAreaService.getAll().then((areas) => {
      this.photoAreas = areas;
      this.selectedImage = null;
      if (this._images) {
        let images = this.filterImages(this._images);
        images = this.sortImages(images);

        let keysToRequest: string[] = [];
        let giList: INgxGalleryImage[] = [];

        for (let i = 0; i < images.length; i++) {
          let x = images[i];
          let key = x.source;
          let curl = null;
          let extension = x.extension;

          if ((x as any).clearCachedUrl) {
            this.clearCachedUrl(key);
            (x as any).clearCachedUrl = false;
          } else curl = this.getCachedUrl(key);

          giList.push({
            leftIcon: this.getConditionIcon(x.condition),
            url: curl,
            descriptionData: this.getDescriptionData(x),
            origin: x,
            extension: extension,
          } as any);

          if (!curl) keysToRequest.push(key);
        }

        let p = keysToRequest.length
          ? this.fileStorageService.getPreSignedURLs(keysToRequest)
          : Promise.resolve([]);

        p.then((urls) => {
          for (var i = 0; i < keysToRequest.length; i++) {
            let gi = giList.find((o) => (o as any).origin.objectKey == keysToRequest[i]);
            gi.url = urls[i];

            this.cachedUrls.push({ key: keysToRequest[i], url: urls[i] });
          }

          giList.forEach((o) => {
            o.small = o.url;
            o.medium = o.url;
            o.big = o.url;
          });

          this.galleryImages = giList;

          if (this.images.length) {
            this.selectedImage = images[0];
          }
        });
      } else {
        this.galleryImages = [];
      }
    });
  }

  private filterImages(images: IGalleryImage[]): IGalleryImage[] {
    this.descriptionFilter.amount = 0;
    for (let filter of this.conditionFilters) {
      filter.amount = 0;
    }

    let res: IGalleryImage[] = [];
    for (let img of images) {
      let filteredForSignatures: boolean = this.signaturesFilter.predicate(img);

      let filteredForDescription: boolean = this.descriptionFilter.predicate(img);
      let filteredForCondition: boolean = false;

      for (let filter of this.conditionFilters) {
        filteredForCondition = filteredForCondition || filter.predicate(img);
      }

      if (filteredForSignatures || (filteredForCondition && filteredForDescription)) {
        res.push(img);
      }
    }
    return res;
  }

  private sortImages(images: IGalleryImage[]): IGalleryImage[] {
    return images.sort((lhs: IGalleryImage, rhs: IGalleryImage) =>
      lhs.isSignature
        ? -1
        : 0 || rhs.isSignature
        ? 1
        : 0 || this.getAreaPosition(lhs.area) - this.getAreaPosition(rhs.area),
    );
  }

  getAreaPosition(area: number): number {
    return this.photoAreas.find((x) => x.area == area).displayOrder ?? 0;
  }

  private setColorScheme() {
    let color: string = this.type == 1 ? '#027fcb' : '#cd0066';
    this.selectedStyle = `4px solid ${color}`;
  }

  private getDescriptionData(img: IGalleryImage): IGalleryImageDescription {
    return {
      areaTitle: img.areaTitle,
      conditionTitle: img.conditionTitle,
      conditionComment: img.conditionComment,
      description: img.description,
      dateTime: img.dateTime,
      isSignature: img.isSignature,
    };
  }

  getConditionIcon(condition): IImageIcon {
    switch (condition) {
      case 0:
        return {
          name: 'fa fa-check-circle',
          title: 'Good Condition',
          colour: 'rgba(86,231,84,0.85)',
        };
      case 1:
        return {
          name: 'fa fa-exclamation-triangle',
          title: 'Minor Damage',
          colour: 'rgba(247, 146, 46, 0.85)',
        };
      case 2:
        return {
          name: 'fa fa-exclamation-circle',
          title: 'Major Damage',
          colour: 'rgba(253,90,90,0.85)',
        };
      case 3:
        return {
          name: 'fa fa-low-vision',
          title: 'Uninspected',
          colour: 'rgba(114,114,114,0.85)',
        };
      default:
        return null;
    }
  }

  viewOdometerImage() {
    const image = this.images.filter((x) => x.area == 5);
    if (image && image.length > 0) {
      this.onShowOdometerPhoto.emit(image[0]);
    }
  }
}

export interface IGalleryFilter {
  enabled?: boolean;
  predicate: (item: IGalleryImage) => boolean;
}

export class ConditionFilter implements IGalleryFilter {
  title: string;
  condition: number;
  enabled = true;
  predicate = (item) => {
    if (item.condition == null && !item.isSignature && this.condition === 3) {
      // increment the displayed count for the 'uninspected' filter to include non-condition photos
      this.amount++;
      return this.enabled;
    }

    const isMatchingCondition = item.condition === this.condition;

    if (isMatchingCondition) {
      // increment the amount to display the total number of photos for each filter
      this.amount++;
    }

    return this.enabled && isMatchingCondition;
  };
  amount: number = 0;

  constructor(condition: number, enabled: boolean = true) {
    this.condition = condition;
    this.enabled = enabled;
    switch (condition) {
      case 0:
        this.title = 'Good Condition';
        break;
      case 1:
        this.title = 'Minor Damage';
        break;
      case 2:
        this.title = 'Major Damage';
        break;
      case 3:
        this.title = 'Uninspected';
        break;
      case 4:
        this.title = 'Not Required';
        break;
    }
  }
}

export class DescriptionFilter implements IGalleryFilter {
  enabled = false;
  predicate = (item) => !this.enabled || item.description;
  amount: number = 0;
  label = 'Show only with Description';
}

export class SignaturesFilter implements IGalleryFilter {
  enabled = true;
  predicate = (item) => this.enabled && item.isSignature;
  label = 'Show Signatures';
}

export interface IGalleryImage {
  id: number;
  source: string;
  dateTime?: Date;
  isSignature: boolean;
  condition?: number;
  conditionTitle?: string;
  conditionComment?: string;
  description?: string;
  area?: number;
  areaTitle?: string;
  extension?: string;
  location?: string;
}
